<template>
  <div>
    <v-dialog v-model="dialog.dialogProgress" persistent width="300" eager>
      <v-card color="primary" dark>
        <v-card-text>
          {{progressMessage}}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-data-table
      v-model="vDataTable.selected"
      :headers="headers"
      :items="vDataTable.data"
      :search="vDataTable.search"
      show-select
      fixed-header
      :page.sync="vDataTable.options.page"
      :itemsPerPage.sync="vDataTable.options.itemsPerPage"
      :options.sync="vDataTable.options"
      height="75vh"
      :footer-props="{
        itemsPerPageText: $t('itemsPerPageText'),
        itemsPerPageAllText: $t('itemsPerPageAllText'),
        showFirstLastPage: true,
        showCurrentPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
      item-key="code"
      class="fill-height">
      <template v-slot:header.win_name="{ header }">
          {{ header.text.toUpperCase() }}
      </template>
      <template v-slot:header.data-table-select="{ on, props }">
        <tr>
          <td>
            <v-simple-checkbox :ripple="false" v-bind="props" v-on="on"></v-simple-checkbox>
          </td>
          <td v-if="vDataTable.selected.length > 0">
            {{vDataTable.selected.length}}
          </td>
        </tr>
      </template>
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Logical Location</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog.dialogAddEdit" max-width="500px" eager>
            <template v-slot:activator="{ on, attrs }">
              <v-btn outlined color="primary" v-bind="attrs" v-on="on" style="text-transform: capitalize">
                <img src="../assets/SoftwareClinicIcon/New.png" height="30" weight="30"/>New
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">  
                      <v-text-field outlined hide-details error-messages :readonly ="CodeReadOnly" label="Code" v-model="vDataTable.editedItem.code"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field outlined hide-details label="Description" v-model="vDataTable.editedItem.description"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <v-select :items="dropDownData.lis_patient_type" v-model="vDataTable.editedItem.patient_type_code" item-text="description" item-value="code" label="Patient Type" 
                                 persistent-hint outlined dense hide-details>
                      </v-select>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">  
                      <v-checkbox v-model="vDataTable.editedItem.print_queue" label="Print Queue" hide-details>
                      </v-checkbox>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                  <v-btn outlined color="primary" @click="close">{{$t('cancel')}}</v-btn>
                  <v-btn outlined color="primary" @click="save">{{$t('save')}}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-divider class="mx-1" inset vertical></v-divider>
          <v-btn outlined color="primary" @click="checkDeleteselected" style="text-transform: capitalize">
            <img src="../assets/SoftwareClinicIcon/Delete.png" height="30" weight="30"/>Delete
          </v-btn>
          <v-divider class="mx-1" inset vertical></v-divider>
          <v-btn outlined color="primary" style="text-transform: capitalize" @click="retrieveSourceSpecimen()">
            <img src="../assets/SoftwareClinicIcon/Find.png" height="30" weight="30"/>{{$t('find')}}
          </v-btn>
          <v-spacer></v-spacer>
          <v-text-field v-model="vDataTable.search" append-icon="mdi-magnify" :label="$t('search')"></v-text-field>
        </v-toolbar>
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.data-table-select="{ isSelected, select }">
        <v-simple-checkbox :value="isSelected" :ripple="false" @input="select($event)" ></v-simple-checkbox>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="teal" small class="mr-2" v-bind="attrs" v-on="on" @click="editItem(item)">edit</v-icon>
          </template>
          <span>Edit</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="pink" small class="mr-2" v-bind="attrs" v-on="on" @click="deleteItemConfirm(item)">delete</v-icon>
          </template>
          <span>Delete</span>
        </v-tooltip>
      </template>
      <template v-slot:item.data-table-no="{ item, index }">
        {{((vDataTable.options.page - 1) * vDataTable.options.itemsPerPage) + index + 1}}
      </template>
      <template v-slot:item.patient_type_code="{ item }">
        <v-select :items="dropDownData.lis_patient_type" v-model="item.patient_type_code" item-text="description" item-value="code" label="Patient Type" readonly persistent-hint outlined dense hide-details>
        </v-select>
      </template>
      <template v-slot:item.print_queue="{ item }">
        <v-simple-checkbox v-model="item.print_queue" disabled hide-details>
        </v-simple-checkbox>
      </template>
      <template v-slot:no-data>
        <v-alert type="info">
          {{$t('noData')}}
        </v-alert>
      </template>
      <template v-slot:no-results>
        <v-alert type="warning">
          {{stringFormat($t('searchNotFound'),vDataTable.search)}}
        </v-alert>
      </template>
      <template v-slot:footer>
        <tr class="sticky-table-footer" style="position: absolute">
          <td>Selected({{vDataTable.selected.length}})s</td> 
        </tr>
      </template>
    </v-data-table> 
  </div>
</template>
<script>
import { mapMutations, mapGetters, mapState } from 'vuex'
export default {
  components: {
  },

  props: ['parentComponent'],

  data () {
    return {
      utils: require('@/utils'),
      stringFormat: require('string-format'),
      appName: process.env.VUE_APP_DB_APP_NAME,
      dialog: {
        dialogProgress: false,
        dialogAddEdit: false,
      },
      vDataTable: {
        search: '',
        selected: [],
        data: [],
        editedIndex: -1,
        editedItem: {
          win_name: '',
          window_comment: ''
        },
        defaultItem: {
          win_name: '',
          window_comment: ''
        },
        options: {
          page: 1,
          itemsPerPage: -1,
          sortBy: [],
          sortDesc: [],
          groupBy: [],
          groupDesc: true,
          multiSort: true,
          // mustSort: true
        },
      },
      dropDownData: [],
      progressMessage: '',
    }
  },

  computed: {
    CodeReadOnly () {
      return !(this.vDataTable.editedIndex === -1)
    },
    formTitle () {
      return this.vDataTable.editedIndex === -1 ? 'New Logical Location' : 'Edit Logical Location'
    },
    headers () {
      return [
        { text: '#', align: 'center', value: 'data-table-no', class: 'text-xl-left body-1 black--text' },
        { text: '', align: 'center', value: 'data-table-select', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('actions'), value: 'actions', sortable: false },
        { text: 'Code', align: 'left', value: 'code', class: 'text-xl-left body-1 black--text' },
        { text: 'Description', align: 'left', value: 'description', class: 'text-xl-left body-1 black--text' },
        { text: 'Patient Type', align: 'left', value: 'patient_type_code', class: 'text-xl-left body-1 black--text' },
        { text: 'Print Queue', align: 'left', value: 'print_queue', class: 'text-xl-left body-1 black--text' },
      ]
    },
  },

  watch: {
    'dialog.dialogAddEdit' (val) {
      val || this.close()
    }
  },

  async created () {
    await this.retrieveSourceSpecimen()
    this.retrieveDropDown()
  },

  mounted () {
  },

  updated () {
  },

  methods: {
    selectLanguage (language) {
    },
    initialize () {
      this.vDataTable.selected = []
      this.vDataTable.editedIndex = -1
      this.vDataTable.editedItem = {
        win_name: '',
        window_comment: ''
      }
      this.vDataTable.defaultItem = {
        win_name: '',
        window_comment: ''
      }
    },
    async retrieveSourceSpecimen () {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')
      await this.axios.post(process.env.VUE_APP_API + '/lis_logical_location/retrieveLogicalLocation' + process.env.VUE_APP_DATABASE_TYPE, {
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.vDataTable.data = response.data.data
            this.initialize()
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
      this.dialog.dialogProgress = false
    },
    retrieveDropDown () {
      this.axios.post(process.env.VUE_APP_API + '/lis_logical_location/retrieveDropDown' + process.env.VUE_APP_DATABASE_TYPE, {
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.dropDownData = response.data.data[0]
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
    },
    async addLogicalLocation (code, description, patientTypeCode, printQueue) {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')
      await this.axios.post(process.env.VUE_APP_API + '/lis_logical_location/addLogicalLocation' + process.env.VUE_APP_DATABASE_TYPE, {
        code: code,
        description: description,
        patient_type_code: patientTypeCode,
        print_queue: printQueue,
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.vDataTable.data.push(this.vDataTable.editedItem)
            this.$swal({type: 'success', title: response.data.reasonText})
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
      this.dialog.dialogProgress = false
    },
    async updateLogicalLocation (code, description, patientTypeCode, printQueue) {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')
      await this.axios.post(process.env.VUE_APP_API + '/lis_logical_location/updateLogicalLocation' + process.env.VUE_APP_DATABASE_TYPE, {
        code: code,
        description: description,
        patient_type_code: patientTypeCode,
        print_queue: printQueue,
      })
        .then(response => {
          if (response.data.isSuccess) {
            Object.assign(this.vDataTable.data[this.vDataTable.editedIndex], this.vDataTable.editedItem)
            this.$swal({type: 'success', title: response.data.reasonText})
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
      this.dialog.dialogProgress = false
    },
    checkDeleteselected () {
      if (this.vDataTable.selected.length > 0) {
        this.$swal({
          text: 'Are you sure you want to delete selected Logical Location?',
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('no')
        }).then((result) => {
          if (result) {
            this.deleteSelected()
          }
        })
      } else {
        this.$swal({type: 'warning', title: 'Please select Logical Location to delete'})
      }
    },
    async deleteSelected () {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')

      var del = []

      await this.utils.asyncForEach(this.vDataTable.selected, async function (x) {
        this.progressMessage = this.stringFormat('Deleting Commodity {}', x.product_line_code)
        var val = await this.deleteLogicalLocation(x)

        if (val !== undefined) {
          del.push(val)
        }
      }.bind(this))

      // del.forEach(x => {
      //   this.vDataTable.selected.splice(this.vDataTable.selected.indexOf(x), 1)
      // })

      for (const x in del) {
        this.vDataTable.selected.splice(this.vDataTable.selected.indexOf(x), 1)
      }

      this.dialog.dialogProgress = false
    },
    async deleteLogicalLocation (item) {
      try {
        this.dialog.dialogProgress = true
        this.progressMessage = this.$t('waiting')
        var code = item.code
        var valRet
        await this.axios.post(process.env.VUE_APP_API + '/lis_logical_location/deleteLogicalLocation' + process.env.VUE_APP_DATABASE_TYPE, {
          code: code
        })
          .then(async response => {
            if (response.data.isSuccess) {
              if (this.vDataTable.data.indexOf(item) >= 0) {
                this.vDataTable.data.splice(this.vDataTable.data.indexOf(item), 1)
              }
              this.$swal({type: 'success', title: response.data.reasonText})
              valRet = item
            } else {
              await this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(async e => {
            await this.$swal({type: 'error', title: e.message})
          })
        return valRet
      } catch (e) {
        await this.$swal({type: 'error', title: e.message})
      } finally {
        this.dialog.dialogProgress = false
      }
    },
    editItem (item) {
      this.vDataTable.editedIndex = this.vDataTable.data.indexOf(item)
      this.vDataTable.editedItem = Object.assign({}, item)
      this.dialog.dialogAddEdit = true
    },
    async deleteItemConfirm (item) {
      // this.vDataTable.editedIndex = this.vDataTable.data.indexOf(item)
      // this.vDataTable.editedItem = Object.assign({}, item)
      this.$swal({
        text: this.stringFormat('Are you sure you want to delete Logical Location {}?', item.code),
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('yes'),
        cancelButtonText: this.$t('no')
      }).then(async (result) => {
        if (result) {
          // var val = await this.deleteWindow(this.vDataTable.editedItem)
          var val = await this.deleteLogicalLocation(item)
          if (val !== undefined) {
            if (this.vDataTable.selected.indexOf(item) >= 0) {
              this.vDataTable.selected.splice(this.vDataTable.selected.indexOf(item), 1)
            }
          }
          // this.vDataTable.editedItem = Object.assign({}, this.vDataTable.defaultItem)
          // this.vDataTable.editedIndex = -1
        }
      })
    },
    close () {
      this.dialog.dialogAddEdit = false
      this.$nextTick(() => {
        this.vDataTable.editedItem = Object.assign({}, this.vDataTable.defaultItem)
        this.vDataTable.editedIndex = -1
      })
    },
    async save () {
      if (this.vDataTable.editedIndex > -1) {
        await this.updateLogicalLocation(this.vDataTable.editedItem.code, this.vDataTable.editedItem.description, this.vDataTable.editedItem.patient_type_code, this.vDataTable.editedItem.print_queue)
      } else {
        await this.addLogicalLocation(this.vDataTable.editedItem.code, this.vDataTable.editedItem.description, this.vDataTable.editedItem.patient_type_code, this.vDataTable.editedItem.print_queue)
      }
      this.close()
    },
    sortTheHeadersAndUpdateTheKey (evt) {
      const headersTmp = this.headers
      const oldIndex = evt.oldIndex
      const newIndex = evt.newIndex
      if (newIndex >= headersTmp.length) {
        let k = newIndex - headersTmp.length + 1
        while (k--) {
          headersTmp.push(undefined)
        }
      }
      headersTmp.splice(newIndex, 0, headersTmp.splice(oldIndex, 1)[0])
      this.table = headersTmp
      this.anIncreasingNumber += 1
    },
  },
}
</script>
<style scoped>
.sticky-table-footer td {
  font-weight: bold;
  position: sticky;
  bottom: 0;
  background-color: #f8f8f8;
  border-top: thin solid rgba(0,0,0,.12);
}
</style>